import styles from './Slots.module.css';

import React from 'react';

import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import FormControlLabel from '@mui/material/FormControlLabel';

import { Slot } from './Slot';

export const Slots = ({ shift, roles, onChange }) => {
    const [ slots, setSlots ] = React.useState(roles.map(role => {
        return {
            shift: shift.id,
            role: role.id,
            name: role.name,
            required: role.required,
            count: shift.slots?.find(s => s.role === role.id)?.count || 0
        };
    }));

    const handleOnChange = (slot) => {
        // Update the slot in place to preserve order
        const newSlots = slots.map(s =>
            s.shift === slot.shift && s.role === slot.role
                ? { ...s, count: slot.count }
                : s
        );

        setSlots(newSlots);

        onChange(newSlots);
    };

    React.useEffect(() => {
        setSlots(prevSlots =>
            roles.map(role => {
                const existing = prevSlots.find(s => s.role === role.id);

                return {
                    shift: shift.id,
                    role: role.id,
                    name: role.name,
                    required: role.required,
                    count: existing ? existing.count : (shift.slots?.find(s => s.role === role.id)?.count || 0)
                };
            })
        );
    }, [ roles, shift.id, shift.slots ]);

    return (
        <div className={ styles.slots }>
            { shift.earlyShiftReward && <div className={ styles.reward }>
                <FormControlLabel
                    label="Reward Early Sign-Up"
                    sx={ { color: '#7cd219ff', marginRight: '20px' } }
                    control={
                        <Checkbox
                            checked={ shift.earlyReward || false }
                            onChange={ handleOnChange }
                            sx={ { '&.Mui-checked': { color: '#1976d2', fontSize: '20px' } } }
                        />
                    }
                />
            </div> }

            <Divider variant='middle' sx={ { my: 3 } } >
                <Chip label="Role Config" color='primary' />
            </Divider>

            <Box sx={ { width: '100%', display: 'flex', flexDirection: 'column', gap: 2 } }>
                { slots.map(slot => (
                    <Slot key={ slot.role } slot={ slot } onChange={ handleOnChange } />
                )) }
            </Box>
        </div>
    );
};